import {
  MealAvoidance,
  MealAvoidanceCategory,
} from '$tablet-app/src/app/recipes/types';

export default function getMealAvoidancesLabel(
  avoidances?: MealAvoidance[]
): string {
  if (!avoidances || !avoidances.length) return 'None';

  if (avoidances.length == 1) return labels[avoidances[0].category];

  return labels[avoidances[0].category] + ' + ' + (avoidances.length - 1);
}

const labels: Record<MealAvoidanceCategory, string> = {
  [MealAvoidanceCategory.GLUTEN]: 'Gluten',
  [MealAvoidanceCategory.DAIRY]: 'Dairy',
  [MealAvoidanceCategory.SEAFOOD]: 'Seafood',
  [MealAvoidanceCategory.RED_MEAT]: 'Red meat',
  [MealAvoidanceCategory.FAT]: 'Fat',
  [MealAvoidanceCategory.CARBS]: 'Carbs',
};
